document.documentElement.classList.remove('no-js');
const drawer = document.querySelector('#MenuDrawer');
const openButton = document.querySelector('[data-drawer-open="menu"]');
const closeButtons = document.querySelectorAll('[data-drawer-close]');
const setDrawer = (open) => {
  if (!drawer) return;
  drawer.classList.toggle('is-open', open);
  drawer.setAttribute('aria-hidden', String(!open));
  openButton?.setAttribute('aria-expanded', String(open));
  closeButtons.forEach((button) => { button.hidden = !open; });
  document.body.classList.toggle('drawer-open', open);
  if (open) drawer.querySelector('button, a')?.focus(); else openButton?.focus();
};
openButton?.addEventListener('click', () => setDrawer(true));
closeButtons.forEach((button) => button.addEventListener('click', () => setDrawer(false)));
document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setDrawer(false); });
const observer = new IntersectionObserver((entries) => entries.forEach((entry) => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } }), { threshold: 0.12 });
document.querySelectorAll('[data-reveal]').forEach((element) => observer.observe(element));
